import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
import preprocessDataForExport from "../../controllers/customControllerForCS/preprocessDataForExport";
import goTo from "../../controllers/goTo";

const Container = styled.div`
  width: 100%;
`;

export default function GeneralTableView({ fields, items }) {
  const { t } = useTranslation();

  let columns = [];

  let rows = [];

  for (let fieldName of fields) {
    let fieldWidth = t(fieldName).length * 10;
    let max = 360;
    let minimum = 180;
    if (fieldWidth > max) fieldWidth = max;
    if (fieldWidth < minimum) fieldWidth = minimum;

    columns.push({
      field: fieldName,
      headerName: t(fieldName),
      width: fieldWidth,
      minWidth: minimum,
    });
  }

  items = preprocessDataForExport(items);

  for (let item of items) {
    let newItem = transformObjectValues(item);
    rows.push({ id: item["Id"], ...newItem });
  }

  function transformObjectValues(obj) {
    // return obj;
    const result = {};

    for (const key in obj) {
      const value = obj[key];

      if (value === null) {
        result[key] = "";
      } else if (typeof value === "string") {
        result[key] = value.toUpperCase();
      } else if (typeof value === "boolean") {
        result[key] = value ? "OUI" : "NON";
      } else {
        result[key] = String(value).toUpperCase();
      }
    }

    return result;
  }

  console.log("rows", rows);

  return (
    <Container className="general-table">
      <Paper sx={{ height: 800, width: "100%" }}>
        <DataGrid
          showCellVerticalBorder
          onRowClick={(params) => {
            goTo(`/employee/${params.id}`)();
            console.log("Row clicked:", params.row);
            // alert(`You clicked on ${params.row.name}`);
          }}
          rows={rows}
          columns={columns}
          hideFooterPagination={true}
          sx={{
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "var(--surfaceSolid) !important",
            },
          }}
          getRowClassName={(params) =>
            params.row["Profile Is Active"] === "NON" ||
            params.row["Is Active"] === "NON"
              ? "inactive-row"
              : "active-row"
          }
        />
      </Paper>
    </Container>
  );
}
